var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.5,
    height: 22.167,
    viewBox: "0 0 26.5 22.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7d7d7d;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #7d7d7d;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-miterlimit: 10;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11284",
    "data-name": "Group 11284",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10727",
    "data-name": "Group 10727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7370",
    "data-name": "Path 7370",
    className: "cls-1",
    d: "M2.221-.833A1.885,1.885,0,1,1,.336,1.053,1.885,1.885,0,0,1,2.221-.833Z",
    transform: "translate(10.229 15.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7369",
    "data-name": "Path 7369",
    className: "cls-2",
    d: "M3.857,17.741H-5.2V.8h25V17.741H10.743",
    transform: "translate(5.2 -0.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10728",
    "data-name": "Group 10728",
    transform: "translate(4.989 20.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7369-2",
    "data-name": "Path 7369",
    className: "cls-2",
    d: "M1.8.8H16",
    transform: "translate(-1.8 -0.8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.babdc4e3023c285a035e6b74bbbd24fb.svg";
export { ForwardRef as ReactComponent };